// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p2-0";
export var leftAlign = "_p2-4";
export var listItem = "_p2-2";
export var listItemWrapper = "_p2-1";
export var operationText = "_p2-3";